module.exports = __webpack_public_path__ + "static/media/url_to_widget2.a30c730f.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/adminPanel/Content Management/assets/url_to_widget2.png
// module id = 1407
// module chunks = 1